$(function () {
  const WPSupport = {
    init() {
      WPSupport.create();
      WPSupport.woo();
      // WPSupport.autoFillService();
      WPSupport.scrollToHash();
      WPSupport.customCPModalWithGForm();
      WPSupport.events();
      WPSupport.wooEvents();
    },
    create() {
      function getUrlParameter(sParam) {
        const sPageURL = window.location.search.substring(1);
        const sURLVariables = sPageURL.split("&");
        let sParameterName;
        let i;

        for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split("=");

          if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined
              ? true
              : decodeURIComponent(sParameterName[1]);
          }
        }
        return false;
      }

      function toggleDisplayStickyPost() {
        const insightsSticky = $(".category");

        const acceptedPaths = [
          "/featured-insights",
          "/news",
          "/press-release",
          "/vi/tin-tuc",
          "/vi/phan-tich-chuyen-sau",
        ];
        if (acceptedPaths.includes(window.location.pathname)) {
          const elePosts = insightsSticky.find(".posts.posts-highlight");
          const elePostBanner = insightsSticky.find(".post-banner");
          const elePostBox = insightsSticky.find(".posts.posts-box");
          const eleFeatureBox = insightsSticky.find(".feature-group");
          const paging = insightsSticky.find(".facetwp-facet-pagination");

          if ($(window).width() > 768) {
            if (
              !getUrlParameter("_paged") &&
              (!getUrlParameter("_categories_radio") ||
                getUrlParameter("_categories_radio") === "featured-insights" ||
                !(
                  (getUrlParameter("_categories_radio") &&
                    getUrlParameter("_categories_radio")) ||
                  ""
                ).split(",").length > 1)
            ) {
              elePosts.stop().show();
              elePostBanner.stop().show();
              eleFeatureBox.stop().show();
              elePostBox.removeClass("spacing");
              paging.removeClass("no-spacing no-border");
            } else {
              elePosts.stop().hide();
              elePostBanner.stop().hide();
              eleFeatureBox.stop().hide();
              elePostBox.addClass("spacing");
              paging.addClass("no-spacing no-border");
            }
          } else {
            if (
              !getUrlParameter("_paged") &&
              (!getUrlParameter("_categories_mobile") ||
                getUrlParameter("_categories_mobile") === "featured-insights" ||
                !(
                  (getUrlParameter("_categories_mobile") &&
                    getUrlParameter("_categories_mobile")) ||
                  ""
                ).split(",").length > 1)
            ) {
              elePosts.stop().show();
              elePostBanner.stop().show();
              eleFeatureBox.stop().show();
              elePostBox.removeClass("spacing");
              paging.removeClass("no-spacing no-border");
            } else {
              elePosts.stop().hide();
              elePostBanner.stop().hide();
              eleFeatureBox.stop().hide();
              elePostBox.addClass("spacing");
              paging.addClass("no-spacing no-border");
            }
          }
        }
      }

      // toggleDisplayStickyPost();

      document.addEventListener("facetwp-loaded", function () {
        setTimeout(function () {
          // toggleDisplayStickyPost();

          if (
            window.location.pathname === "/featured-insights" &&
            (!getUrlParameter("_categories_radio") ||
              getUrlParameter("_categories_radio") === "featured-insights")
          ) {
            $(".facetwp-checkbox").first().addClass("checked");
          }

          // Replace text for insights
          if (
            window.location.pathname === "/featured-insights" ||
            window.location.pathname === "/vi/phan-tich-chuyen-sau"
          ) {
            $(".facetwp-facet-categories .facetwp-checkbox").each(function () {
              const self = $(this);

              if (self.find(".facetwp-display-value").text() === "Insights") {
                self.find(".facetwp-display-value").text("All");
              }

              if (
                self.find(".facetwp-display-value").text() ===
                "Phân tích chuyên môn"
              ) {
                self.find(".facetwp-display-value").text("Tất cả");
              }
            });
          }

          if (getUrlParameter("s")) {
            const keywords = $(".panel.panel-search h2").find("span").text();
            var context = document.querySelector(
              ".result .list.facetwp-template"
            );
            var instance = new Mark(context);
            instance.mark(keywords, {
              "accuracy": {
                "value": "exactly",
                "limiters": [",", "."]
              },
              diacritics: true,
            });
          }
        }, 350);
      });

      WPSupport.transRating();

      $("body").on("DOMSubtreeModified", ".p-detail.rating", function () {
        setTimeout(function () {
          WPSupport.transRating();
        }, 150);
      });
    },
    transRating() {
      if ($(".kk-star-ratings").length) {
        const lang = $("html")[0].lang;

        $(".kk-star-ratings").each(function () {
          const rating = $(this);

          const orgText = rating
            .find(".kksr-legend")
            .text()
            .replace(/\n|\r|\t/g, "");

          if (
            (lang === "en-US" && orgText.includes("rating")) ||
            (lang === "vi-VN" && orgText.includes("bình chọn"))
          ) {
            return;
          }

          if (orgText) {
            const partsText = orgText.split(" ").filter((item) => item);

            if (partsText.length) {
              if (orgText.includes("ratings") && lang === "en-US") {
                if (partsText[2] === "0" || partsText[2] === "1") {
                  partsText[3] = "rating";
                }

                rating.find(".kksr-legend").text(partsText.join(" "));
              }

              if (lang === "vi-VN") {
                rating
                  .find(".kksr-legend")
                  .text(
                    `${partsText[0]} trong tổng số ${partsText[2]} bình chọn`
                  );
              }
            }
          }
        });
      }
    },
    woo() {
      // Checkout
      $(".fooevents-attendee")
        .find("select, input")
        .on("change keyup", function () {
          const p = $(this).closest(".fooevents-attendee");

          if (t) {
            clearTimeout(t);
          }

          t = setTimeout(function () {
            const count = p.find(".validate-required").length;
            let countValidated = 0;

            p.find(".form-row select, .form-row input").each(function () {
              if ($(this).val() && $(this).val() !== "--") {
                countValidated += 1;
              }
            });

            if (count !== countValidated) {
              p.find(".fooevents-attendee-number .tick").remove();
            } else {
              if (!p.find(".tick").length) {
                p.find(".fooevents-attendee-number")
                  .append(`<svg class="tick" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3757 23.4769L25.2336 9.5008L22.0664 6.58691L12.3757 17.1203L7.75321 12.0959L4.58594 15.0098L12.3757 23.4769ZM22.1259 8.00048L22.1253 7.9999L12.3761 18.5968L12.3767 18.5974L22.1259 8.00048ZM12.3757 21.9999L12.3761 21.9994L6 15.0688L7.69488 13.5095L7.69433 13.5089L5.99893 15.0687L12.3757 21.9999Z" fill="#008000"/>
              </svg>`);
              }
            }
          }, 350);
        });

      $(".fooevents-attendee").each(function () {
        const attendee = $(this);
        attendee
          .children()
          .wrapAll('<div style="display: flex; flex-wrap: wrap;"></div>');
        attendee.children().wrapAll('<div data-accordion-content=""></div>');
        attendee.prepend(
          `<h4 class="fooevents-attendee-number closed" data-toggle-accordion="">${attendee
            .find(".fooevents-attendee-number")
            .text()}</h4>`
        );
      });

      $(document).on("click", "[data-toggle-accordion]", function () {
        const self = $(this);

        self.toggleClass("closed");
        self
          .closest(".fooevents-attendee")
          .find("[data-accordion-content]")
          .stop()
          .slideToggle("slow", function () {
            Sticksy.hardRefreshAll();
          });
      });

      $(window).on("scroll", function () {
        if ($(".page-template-checkout").length && $(".review-info").length)
          Sticksy.hardRefreshAll();
      });

      $("#fooevents-attendee-1 [data-toggle-accordion]").trigger("click");

      function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      }

      $(document).on("change", "[data-auto-fill-attendee]", function (e) {
        const self = $(this);
        const checked = e.target.checked;

        if (checked) {
          const billingFields = self
            .closest("#customer_details")
            .find(".woocommerce-billing-fields");
          const salutation = billingFields
            .find('select[name="billing_salutation"]')
            .val();
          const billing_first_name = billingFields
            .find('input[name="billing_first_name"]')
            .val();
          const billing_last_name = billingFields
            .find('input[name="billing_last_name"]')
            .val();
          const billing_company = billingFields
            .find('input[name="billing_company"]')
            .val();
          const billing_phone = billingFields
            .find('input[name="billing_phone"]')
            .val();
          const billing_email = billingFields
            .find('input[name="billing_email"]')
            .val();
          const billing_prefix_phone = billingFields
            .find('select[name="billing_prefix_phone"]')
            .val();
          const job_title = billingFields.find('input[name="billing_job_title"]').val();

          const firstAttendee = $(".fooevents-attendee").eq(0);
          if (firstAttendee.length) {
            firstAttendee
              .find(".form-row")
              .eq(5)
              .find("select")
              .val(capitalizeFirstLetter(salutation));
            firstAttendee
              .find(".form-row")
              .eq(0)
              .find("input")
              .val(billing_first_name);
            firstAttendee
              .find(".form-row")
              .eq(1)
              .find("input")
              .val(billing_last_name);
            firstAttendee
              .find(".form-row")
              .eq(2)
              .find("input")
              .val(billing_email);
            firstAttendee
              .find(".form-row")
              .eq(3)
              .find("input")
              .val(billing_phone);
            firstAttendee
              .find(".form-row")
              .eq(3)
              .find("select")
              .val(billing_prefix_phone);
            firstAttendee.find(".form-row").eq(6).find("input").val(job_title);
            firstAttendee
              .find(".form-row")
              .eq(4)
              .find("input")
              .val(billing_company);
          }
        }
      });

      let t;
      $("#customer_details .woocommerce-billing-fields")
        .find('input[name="billing_company"]')
        .on("keyup", function () {
          const val = $(this).val();

          if (t) {
            clearTimeout(t);
          }

          t = setTimeout(function () {
            $(".fooevents-attendee").each(function () {
              const at = $(this);
              at.find(".form-row").eq(4).find("input").val(val);
            });
          }, 5000);
        });

      // var stickyEl;
      // if (
      //   $(
      //     ".woocommerce-checkout .woocommerce form.woocommerce-checkout .order-review .review-info"
      //   ).length
      // ) {
      //   stickyEl = new Sticksy(".review-info", {
      //     topSpacing: 24,
      //   });
      // }

      // Cart
      $(document).on(
        "click",
        '.cart-coupon button[name="coupon_cart"]',
        function () {
          const self = $(this);
          self
            .closest(".woocommerce")
            .find('button[name="apply_coupon"]')
            .trigger("click");
        }
      );

      $(document).on(
        "input",
        '.cart-coupon input[name="coupon_cart"]',
        function () {
          const self = $(this);
          self
            .closest(".woocommerce")
            .find('input[name="coupon_code"]')
            .val(self.val());
        }
      );

      $("[data-toggle-login]").on("click", function () {
        $(this)
          .closest(".woocommerce")
          .find(".woocommerce-form.woocommerce-form-login.login")
          .stop()
          .slideToggle();
      });

      $(document).on("click", "[data-coupon]", function () {
        const self = $(this);
        if (self.hasClass("disabled")) return;
        self.closest(".list").find(".selected").removeClass("selected");

        self.addClass("selected");
      });

      $(document).on("click", "[data-apply-offer]", function () {
        const self = $(this);

        const selectedOffer = self
          .closest("[data-popup-content]")
          .find(".list .selected");
        if (selectedOffer.length) {
          const coupon = selectedOffer.data("coupon");
          self
            .closest(".woocommerce")
            .find('input[name="coupon_code"]')
            .val(coupon);
          self
            .closest(".woocommerce")
            .find('button[name="apply_coupon"]')
            .trigger("click");
        }
      });

      $(document).on("click", ".quantity-btn", function () {
        const self = $(this);
        const inp = self.closest(".wrap-inp-quantity").find(".qty");
        const currentVal = parseInt(inp.val());

        if (self.hasClass("quantity-decrease")) {
          inp.val(currentVal - 1 < 0 ? 0 : currentVal - 1);
        } else {
          inp.val(currentVal + 1);
        }

        self
          .closest(".woocommerce-cart-form")
          .find('button[name="update_cart"]')
          .prop("disabled", false);
      });

      // Account
      $(document).on(
        "click",
        ".woocommerce-form-login [data-toggle], .woocommerce-form-register [data-toggle]",
        function (e) {
          e.preventDefault();
          const self = $(this);
          if (self.data("toggle") === "signup") {
            self.closest(".u-columns").find(".u-column1").stop().hide();
            self.closest(".u-columns").find(".u-column2").stop().show();
          } else if (self.data("toggle") === "signin") {
            self.closest(".u-columns").find(".u-column1").stop().show();
            self.closest(".u-columns").find(".u-column2").stop().hide();
          }
        }
      );

      setTimeout(function () {
        $(
          ".woocommerce-checkout .woocommerce .form-row label .required "
        ).addClass("show");
      }, 350);

      // Cart
      $(document).on(
        "change input",
        ".woocommerce-cart .product-quantity .wrap-inp-quantity .input-text",
        function (e) {
          if (!e.target.value) return;
          const btn = $(this)
            .closest(".shop_table")
            .find("button[name='update_cart']");
          setTimeout(function () {
            btn.trigger("click");
          }, 350);
        }
      );

      $(document).on("click", ".quantity-btn", function () {
        const btn = $(this)
          .closest(".shop_table")
          .find("button[name='update_cart']");
        setTimeout(function () {
          btn.trigger("click");
        }, 350);
      });
    },
    autoFillService() {
      const pathname = window?.location?.pathname;
      const parts = pathname.split("/");
      const lang = $("html")[0].lang;

      const services = {
        // Executive search & selection
        "executive-search": "executive-search-selection",
        "tuyen-dung-nhan-su-cap-cao": "executive-search-selection",

        // HR consulting services
        "hr-consulting": "hr-consulting-services",
        "tu-van-nhan-su": "hr-consulting-services",

        // HR outsourcing services
        "hr-outsourcing-services": "hr-outsourcing-services",
        "dich-vu-nhan-su-thue-ngoai": "hr-outsourcing-services",

        // HR training courses
        "human-capital-solution-training-workshops": "hr-training-courses",
        "chuong-trinh-dao-tao-danh-cho-nhan-su": "hr-training-courses",

        // Market entry services
        "corporate-services": "market-entry-services",
        "dich-vu-tu-van-doanh-nghiep": "market-entry-services",

        // Payroll services
        "payroll-services": "payroll-services",
        "dich-vu-tinh-luong": "payroll-services",

        // Talentnet-Mercer salary surveys
        "talentnet-mercer-salary-surveys": "talentnet-mercer-salary-surveys",
        "khao-sat-luong-talentnet-mercer": "talentnet-mercer-salary-surveys",
      };

      if (
        parts.length > 1 &&
        $('form[action^="/contact#gf"], .long-form-v1, [data-download-pdf]')
          .length &&
        (parts[1] === "our-services" || parts[2] === "dich-vu")
      ) {
        $(
          'form[action^="/contact#gf"], .long-form-v1, [data-download-pdf]'
        ).each(function () {
          const form = $(this);
          let slug = "";

          if (parts[1] === "our-services") {
            slug = parts[2] || "";
          } else {
            slug = parts[3] || "";
          }

          form
            .find(`input[type="checkbox"][value="${services[slug]}"]`)
            .prop("checked", true);
        });
      }
    },
    scrollToHash() {
      const hash = window.location.hash;

      if ($(`[data-scroll-to-me="${hash.replace("#", "")}"]`).length) {
        $("html, body").animate(
          {
            scrollTop:
              $(`[data-scroll-to-me="${hash.replace("#", "")}"]`).offset().top -
              $("header").height(),
          },
          750
        );
      }

      $(document).on("click", "[data-anchor]", function (e) {
        e.preventDefault();
        const id = $(this).attr("href");
        if ($(`[data-scroll-to-me="${id.replace("#", "")}"]`).length) {
          $("html, body").animate(
            {
              scrollTop:
                $(`[data-scroll-to-me="${id.replace("#", "")}"]`).offset().top -
                $("header").height(),
            },
            750
          );
        }
      });

      const urlParams = new URLSearchParams(window.location.search);
      const p = urlParams.get("our-offering");
      if (p) {
        if ($(`[data-scroll-to-me="our-offering"]`).length) {
          $("html, body").animate(
            {
              scrollTop:
                $(`[data-scroll-to-me="our-offering"]`).offset().top -
                $("header").height(),
            },
            750
          );
        }

        const idx = $(`[data-introduction-item][data-name="${p}"]`)
          .first()
          .closest("[data-product]")
          .data("swiper-slide-index");
        $(".w-introduction [data-dropdown]")
          .eq(idx)
          .find("[data-dropdown-element]")
          .trigger("click");
        const id = $(`[data-introduction-item][data-name="${p}"]`)
          .first()
          .closest("[data-swiper-slider]")
          .attr("id");
        const slider = document.getElementById(id);
        if (slider && slider?.swiper) {
          slider.swiper.slideTo(idx);
        }
      }
    },
    customCPModalWithGForm() {
      const cpModal = $(".cp_id_dc9bc");
      const gFormID = cpModal.find("form").attr("id");
      // console.log('%cwp-support.js line:746 gFormID', 'color: #007acc;', gFormID);
      $(document).on(
        "gform_confirmation_loaded",
        function (event, form_id, current_page) {
          if (!gFormID) {
            localStorage.removeItem("IS_SUBMIT_SURVEY_CP_MODAL");
          } else {
            if (`gform_${form_id}` === gFormID) {
              localStorage.setItem("IS_SUBMIT_SURVEY_CP_MODAL", "true");
            } else {
              localStorage.removeItem("IS_SUBMIT_SURVEY_CP_MODAL");
            }
          }
        }
      );

      function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(";").shift();
      }

      if (gFormID) {
        // console.log('%cwp-support.js line:768 getCookie()', 'color: #007acc;', getCookie(gFormID.replace("gform_", "gpoll_form_")));
        if (
          getCookie(gFormID.replace("gform_", "gpoll_form_")) ||
          localStorage.getItem("IS_SUBMIT_SURVEY_CP_MODAL")
        ) {
          cpModal.remove();
        }
      }
      // gpoll_form_7
    },
    events() {
      if ($(`[data-tab-element][data-name="event-gallery-1"]`).length) {
        $(`[data-tab-element][data-name="event-gallery-1"]`).trigger("click");
      }
    },
    wooEvents() {
      // Update Quantity
      let count = 0;
      let allowGetTotalCart = false;
      $(document).on(
        "DOMSubtreeModified",
        ".woocommerce-cart-form",
        function () {
          if ($(this).hasClass("processing") && !allowGetTotalCart) {
            count += 1;
          }

          if (count === 2) {
            // Reset count
            count = 0;
            allowGetTotalCart = true;

            setTimeout(function () {
              // Get total_cart
              $.ajax({
                url: talentnet?.ajax_url,
                type: "POST",
                data: {
                  action: "get_cart_count",
                },
                success: function (response) {
                  allowGetTotalCart = false;
                  $("header .cta-cart").find(".number").remove();
                  $("header .cta-cart").append(
                    `<span class="number">${response}</span>`
                  );
                },
                fail: function () {
                  allowGetTotalCart = false;
                },
              });
            }, 1000);
          }
        }
      );
    },
  };

  WPSupport.init();
});
